
import React from 'react';
import { Link } from "react-router-dom";

const HelpCenter = () => {
  return (
    <div className='container py-10'>
        <h1 className='heading-one !text-secondary-n-400 mb-6'>Help Center</h1>
       {/* <div className='grid grid-cols-2 gap-3'>
       <div className="rounded-lg overflow-hidden shadow-lg bg-white">
      <div className="px-6 py-4">
        <div className="font-bold text-xl mb-2">Open Chat</div>
        <p className="text-gray-700 text-base">
          Click below to start a view chat!
        </p>
      </div>
      <div className="px-6 py-4">
        <button className="bg-primary-yellow-500  text-white font-bold py-2 px-4 rounded">
          <Link href="/dashboard/help-center/chat">Start Chat</Link>
        </button>
      </div>
    </div>
    <div className="rounded-lg overflow-hidden shadow-lg bg-white">
      <div className="px-6 py-4">
        <div className="font-bold text-xl mb-2">Add Frequently Asked Questions</div>
        <p className="text-gray-700 text-base">
          Add FAQ's.
        </p>
      </div>
      <div className="px-6 py-4">
        <button className="bg-primary-yellow-500 text-white font-bold py-2 px-4 rounded">
          <Link to={"/dashboard/help-center/faq"}>
          Explore FAQ
          </Link>
        </button>
      </div>
    </div>
       </div> */}
        

   

        
    </div>
  )
}

export default HelpCenter